// extracted by mini-css-extract-plugin
module.exports = {"roundIcon":"f3","disabled":"f4"};